<template>
  <nav class="navbar navbar-vertical fixed-start navbar-expand-md navbar-vibrant navbar-dark" id="sidebar">
    <div class="test"></div>
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarCollapse"
        aria-controls="sidebarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Brand -->
      <router-link tag="a" class="navbar-brand" to="/">
        <div v-if="isLogoLoading" class="skeleton-logo"></div>
        <img
          v-else
          :src="logoUrl"
          class="navbar-brand-img mx-auto"
          alt="..." />
      </router-link>

      <div class="navbar-user d-md-none">
        <!-- Dropdown -->
        <div class="dropdown">
          <!-- Toggle -->
          <a
            href="#"
            id="sidebarIcon"
            class="dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="avatar avatar-sm avatar-online">
              <span class="avatar-title rounded-circle">U</span>
            </div>
          </a>

          <!-- Menu -->
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="sidebarIcon">
            <a href="./sign-in.html" class="dropdown-item">Logout</a>
          </div>
        </div>
      </div>

      <div class="collapse navbar-collapse" id="sidebarCollapse">
        <ul class="navbar-nav accordion mt-5" style="z-index: 99999999" role="tablist">
          <li class="nav-item" v-for="(item, index) in listMenu" :key="`${item.name}${index}`">
            <a
              :class="`nav-link text-colors mx-3 ${
                item.children && item.children.length > 0 && index > 0 ? 'collapsed' : ''
              } ${item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'}`"
              v-b-toggle="item.link"
              data-navtype="parent"
              v-if="item.children && item.children.length > 0"
            >
              <i :class="`fe fe-${item.icon}`"></i>
              {{ item.name }}
            </a>
            <router-link
              tag="a"
              :class="`nav-link text-colors mx-3 ${
                item.children && item.children.length > 0 && index > 0 ? 'collapsed' : ''
              } ${item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'}`"
              :to="item.children && item.children.length > 0 ? `#${item.link}` : item.link"
              v-else
            >
              <i :class="`fe fe-${item.icon}`"></i>
              {{ item.name }}
            </router-link>
            <!-- ${(item.children && (item.children.length > 0) && index == 0) || item.click ? 'show' : ''} -->
            <b-collapse
              :id="item.children && item.children.length > 0 ? item.link : ''"
              v-if="item.children && item.children.length > 0"
              :visible="item.children && item.children.length > 0 && index == 0"
              accordion="my-accordion"
              role="tabpanel"
            >
              <ul class="nav nav-sm flex-column accordion" role="tablist">
                <li class="nav-item" v-for="(a, i) in item.children" :key="i">
                  <a
                    :class="`nav-link text-colors mx-3 ${
                      a.children && a.children.length > 0 && index > 0 ? 'collapsed' : ''
                    } ${activePath === a.link ? 'isActives text-primary fFw-bolder' : 'hovers fw-lighter'}`"
                    v-b-toggle="a.link"
                    data-navtype="parent"
                    v-if="a.children && a.children.length > 0"
                  >
                    {{ a.name }}
                  </a>
                  <router-link
                    tag="a"
                    :class="`nav-link mx-3 ${
                      activePath === a.link
                        ? 'isActives bg-white rounded-2 text-black fw-bolder'
                        : 'hovers text-white fw-lighter'
                    }`"
                    :to="a.link"
                    v-else
                  >
                    {{ a.name }}
                  </router-link>
                  <b-collapse
                    :id="a.children && a.children.length > 0 ? a.link : ''"
                    v-if="a.children && a.children.length > 0"
                    :visible="a.children && a.children.length > 0 && index == 0"
                    accordion="my-accordion-2"
                    role="tabpanel"
                  >
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-for="(lv3, idx) in a.children" :key="idx">
                        <router-link
                          tag="a"
                          :class="`nav-link mx-3 ${lv3.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
                          :to="lv3.link"
                        >
                          {{ lv3.name }}
                        </router-link>
                      </li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>

        <!-- Divider -->
        <hr class="navbar-divider my-3" />
      </div>
      <!-- Divider -->
      <hr class="navbar-divider my-3" />
    </div>
    <!-- / .navbar-collapse -->
  </nav>
</template>

<script>
export default {
  name: "SidebarComponent",
  data() {
    return {
      isMasterDataOpen: false,
      isIdpManagementOpen: false,
      isSettingOpen: false,
      role: "",
      listMenu: [],
      logoUrl: "",
      isLogoLoading: true,
      profileData: null,
      menus: [
        {
          icon: "home",
          name: "Dashboard",
          link: "/",
        },
        {
          icon: "database",
          name: "Master Data",
          link: "masterData",
          children: [
            {
              name: "Training Method",
              link: "/master-data/trainingMethod",
            },
            {
              name: "Training Type",
              link: "/master-data/trainingType",
            },
            {
              name: "Project Type",
              link: "/master-data/projectType",
            },
            {
              name: "Project Role",
              link: "/master-data/projectRole",
            },
            {
              name: "Coaching",
              link: "/master-data/coaching",
            },
            {
              name: "LDP",
              link: "/master-data/ldp",
            },
            {
              name: "Training",
              link: "/master-data/training",
            },
          ],
        },
        {
          icon: "file-text",
          name: "My IDP",
          link: "/myidp",
        },
        {
          icon: "users",
          name: "My Teams IDP",
          link: "/myteamidp",
        },
        {
          icon: "user-check",
          name: "IDP Examination",
          link: "/idpexamination",
        },

        {
          icon: "monitor",
          name: "IDP Management & Monitoring",
          link: "management",
          children: [
            {
              name: "Structured Learning",
              link: "/idpManagement/structured-learning",
            },
            {
              name: "Social Learning",
              link: "/idpManagement/social-learning",
            },
          ],
        },
        {
          icon: "settings",
          name: "Settings",
          link: "settings",
          children: [
            {
              name: "IDP Period",
              link: "/setting/idp-period",
            },
            {
              name: "Role Menu Management",
              link: "/setting/menu-management",
            },
            {
              name: "Notification Event",
              link: "/setting/notification-event",
            },
            {
              name: "Notification Template",
              link: "/setting/notification-template",
            },
          ],
        },
      ],
    };
  },
  computed: {
    activePath() {
      return this.$route.path.split("?")[0];
    },
  },
  mounted() {
    // Check logo initially
    this.getRoleMenu();
    this.checkLogo();
    
    // Listen for role changes from App.vue
    this.$root.$on("roles", (body) => {
      this.role = body;
      // Recheck logo when roles are loaded
      this.checkLogo();
    });

    // Listen for window resize to adjust logo for mobile/desktop
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    isMobileDevice() {
      // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
      return window.innerWidth <= 768;
    },
    handleResize() {
      this.checkLogo();
    },
    checkLogo() {
      const isMobile = this.isMobileDevice();

      this.logoUrl = isMobile ? "/img/logo-bib-white.png" : "/img/logo-bib-color.png";
      this.isLogoLoading = false;
    },
    filterMenu() {
      // if (this.role === "HR") {
      //   return this.menus;
      // } else if (this.role === "Employee") {
      //   return this.menus.filter((item) => {
      //     return (
      //        item.link !== "/idpexamination" &&
      //       item.link !== "masterData" &&
      //       item.link !== "/myteamidp" &&
      //       item.link !== "settings" &&
      //       item.link !== "management"
      //     );
      //   });
      // } else if (this.role === "Manager") {
      //   return this.menus.filter((item) => {
      //     return (
      //        item.link !== "/idpexamination" &&
      //       item.link !== "settings" &&
      //       item.link !== "management"
      //     );
      //   });
      // }
      // else if (this.role === "lnd") {
      //   return this.menus.filter((item) => {
      //     return (
      //        item.link !== "/idpexamination" &&
      //       item.link !== "masterData" &&
      //       item.link !== "/myidp" &&
      //       item.link !== "/myteamidp" &&
      //       item.link !== "settings"
      //     );
      //   });
      // }else if (this.role === "assessor") {
      //   return this.menus.filter((item) => {
      //     return (
      //       item.link !== "masterData" &&
      //       item.link !== "management" &&
      //       item.link !== "/myidp" &&
      //       item.link !== "/myteamidp" &&
      //       item.link !== "settings"
      //     );
      //   });
      // }
    },
    getRoleMenu() {
      this.$store.dispatch("role/getRoleMenu").then(() => {
        let data = this.$store.getters["role/roleMenu"]

        this.listMenu = data.map((item) => {
          let child = [];
          let TabMenu = [];
          if (
            item.to !== "/dashboard" &&
            item.to !== "/myidp" &&
            item.to !== "/myteamidp" &&
            item.to !== "/idpexamination" &&
            Array.isArray(item.children)
          ) {
            child = item.children.map((item) => {
              return {
                name: item.title,
                link: item.to,
                privilages: item.privilages,
                tabMenu: item.children,
              };
            });
          } else {
            TabMenu = item.children;
          }
          return {
            icon: item.icon,
            name: item.title,
            link_alias: item.to,
            link: item.to === null ? item.title.replace(/\s/g, "") : item.to,
            children: child,
            tabMenu: TabMenu,
            privilages: item.privilages,
          };
        });
        localStorage.setItem("listMenu", JSON.stringify(this.listMenu));
        this.$root.$emit("listMenu", this.listMenu);
      });
    },
    toggleMasterData() {
      this.isMasterDataOpen = !this.isMasterDataOpen;
    },
    toggleSettings() {
      this.isSettingOpen = !this.isSettingOpen;
    },
    toggleIdpManagement() {
      this.isIdpManagementOpen = !this.isIdpManagementOpen;
    },
    navClick(link) {
      const idx = this.menus.findIndex((e) => e.link === link);
      if (this.menus[idx].children) {
        let selected = this.menus[idx];

        if (this.$refs[selected.link][0].classList.contains("collapsed")) {
          this.$refs[selected.link][0].classList.remove("collapsed");
        } else {
          this.$refs[selected.link][0].classList.add("collapsed");
        }
      }
    },
  },
};
</script>

<style scoped>
.skeleton-logo {
  background-color: #eee;
  background-image: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  width: 100%;
  height: 50px;
  animation: skeleton-animation 1.5s ease-in-out infinite;
}

@keyframes skeleton-animation {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}
</style>
